import { render } from "./Percentage.vue?vue&type=template&id=2cc0e197"
import script from "./Percentage.vue?vue&type=script&lang=js"
export * from "./Percentage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../github.com:rancher/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__